var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.7467 5.63317C13.0467 2.55317 10.3601 1.1665 8.00006 1.1665C8.00006 1.1665 8.00006 1.1665 7.9934 1.1665C5.64006 1.1665 2.94673 2.5465 2.24673 5.6265C1.46673 9.0665 3.5734 11.9798 5.48006 13.8132C6.18673 14.4932 7.0934 14.8332 8.00006 14.8332C8.90673 14.8332 9.8134 14.4932 10.5134 13.8132C12.4201 11.9798 14.5267 9.07317 13.7467 5.63317Z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9999 8.97344C9.1597 8.97344 10.0999 8.03324 10.0999 6.87344C10.0999 5.71364 9.1597 4.77344 7.9999 4.77344C6.8401 4.77344 5.8999 5.71364 5.8999 6.87344C5.8999 8.03324 6.8401 8.97344 7.9999 8.97344Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationGray);
export default __webpack_public_path__ + "static/media/location_gray.4afa6e82d2b52c556c5a51901b591604.svg";
export { ForwardRef as ReactComponent };